import type { RouteRecordRaw } from 'vue-router'
import {
  DangerIcon,
  PaperIcon,
  VipGem,
  PlacementIcon,
  MedalStarIcon
} from '@/components/icons'
export const UserRoutes: Array<RouteRecordRaw> = [
  {
    path: '/user',
    meta: { middleware: 'auth', requiresAuth: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: 'subscriptions',
        name: 'user-subscriptions',
        component: () => import('@/views/user/subscriptions.vue'),
        meta: {
          breadcrumb: [
            {
              text: 'خرید اشتراک',
              to: '/user/subscriptions',
              icon: VipGem
            }
          ]
        }
      },
      {
        path: 'crash-report',
        name: 'crash-report',
        component: () => import('@/views/user/crash-report.vue'),
        meta: {
          breadcrumb: [
            {
              text: 'گزارش خرابی',
              to: '/user/crash-report',
              icon: DangerIcon
            }
          ]
        }
      },
      {
        path: 'transactions',
        name: 'transactions',
        component: () => import('@/views/user/transactions.vue'),
        meta: {
          breadcrumb: [
            {
              text: ' تراکنش ها',
              to: '/user/transactions',
              icon: PaperIcon
            }
          ]
        }
      },
      {
        path: 'placement-history',
        name: 'placement-history',
        component: () => import('@/views/user/placement-exam-history.vue'),
        meta: {
          breadcrumb: [
            {
              text: 'آزمون تعیین سطح',
              to: '/user/transactions',
              icon: PlacementIcon
            }
          ]
        }
      },
      {
        path: 'certificate',
        name: 'certificate',
        component: () => import('@/views/user/certificate/list.vue'),
        meta: {
          breadcrumb: [
            {
              text: 'مدارک من',
              to: '/user/certificate',
              icon: MedalStarIcon
            }
          ]
        }
      },
      {
        path: 'certificate/:courseId',
        name: 'private_certificate',
        component: () => import('@/views/user/certificate/[courseId].vue')
      }
    ]
  },
  {
    path: '/course/:courseId/certificate/:userId',
    meta: { requiresAuth: false },
    component: () => import('@/views/user/certificate/public-certificate.vue')
  }
]
